/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export enum DecompressibleState {
  Enabled,
  Disabled,
}

export type DecompressibleStateArgs = DecompressibleState;

export function getDecompressibleStateEncoder(): FixedSizeEncoder<DecompressibleStateArgs> {
  return getEnumEncoder(DecompressibleState);
}

export function getDecompressibleStateDecoder(): FixedSizeDecoder<DecompressibleState> {
  return getEnumDecoder(DecompressibleState);
}

export function getDecompressibleStateCodec(): FixedSizeCodec<
  DecompressibleStateArgs,
  DecompressibleState
> {
  return combineCodec(
    getDecompressibleStateEncoder(),
    getDecompressibleStateDecoder()
  );
}
